export const getThumbnailImg = (imgId: string) => `${process.env.REACT_APP_STORAGE}/${imgId}/thumbnail.jpg`;
export const getResizedImg = (imgId: string) => `${process.env.REACT_APP_STORAGE}/${imgId}/resized.jpg`;
